/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TargetTemplateModel } from '../../models/target-template-model';

export interface SaveTargetTemplate$Params {
      body?: TargetTemplateModel
}

export function SaveTargetTemplate(http: HttpClient, rootUrl: string, params?: SaveTargetTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<TargetTemplateModel>> {
  const rb = new RequestBuilder(rootUrl, SaveTargetTemplate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TargetTemplateModel>;
    })
  );
}

SaveTargetTemplate.PATH = '/api/Supervisor/SaveTargetTemplate';
